import gbAntButtonCountDown from "./src/gb-ant-button-count-down.vue";
const gbAntButtonCountDownCompenet = function(Vue) {
  Vue.component(gbAntButtonCountDown.name, gbAntButtonCountDown);
};
export default gbAntButtonCountDownCompenet;
